import React, {
    useEffect,
    useRef,
    useLayoutEffect,
    useState,
    useMemo,
} from "react";
import { useInView } from "react-intersection-observer";
import { Slide, Fade } from "react-awesome-reveal";
import FluidSimulation from "fluid-simulation-react";
import Marquee from "react-fast-marquee";
import careersbg from "../../../../assets/images/careersbgfullcover.jpg";

import row1 from "../../../../assets/images/row1.svg";
import row2 from "../../../../assets/images/row2.svg";
import row3 from "../../../../assets/images/row3.svg";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

function Careers({ pageInView, setPageInView }) {
    const scenecareersRef = useRef(null);
    const bgRef = useRef(null);

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        message: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        const handleScroll = () => {
            if (bgRef.current) {
                const scrollY = window.scrollY;
                const translateY = scrollY * 0.1;
                const scale = 1 + scrollY * 0.001;
                gsap.to(bgRef.current, {
                    y: translateY,
                    scale: scale,
                    duration: 1.5,
                    ease: "power2.out",
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        gsap.registerPlugin(SplitText);
        const innovationpara = new SplitText("#innovationpara", {
            type: "words",
        });

        gsap.from(innovationpara.words, {
            duration: 3,
            opacity: 0,
            ease: "power1.inOut",
            stagger: {
                each: 0.13,
                from: "start",
            },
        });

        return () => {
            innovationpara.revert();
        };
    }, []);

    const scrollToElement = (id) => {
        const element = document.getElementById(id);

        if (element) {
            gsap.to(window, {
                scrollTo: {
                    y: element.offsetTop,
                    offsetY: 100,
                },
                ease: "power2.inOut",
            });
        }
    };

    const { ref, inView, entry } = useInView({
        triggerOnce: false,
        threshold: 0.5,
    });

    useEffect(() => {
        if (inView) {
            console.log("pageview is mission");
            if (inView) {
                setPageInView("careers");
            }
        }
    }, [inView]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const GOOGLE_FORM_URL =
                "https://docs.google.com/forms/d/1x2JmkYbm9ty8VF9yoX_dqEZJKE44Qq9vwlsPMZfxK0o/formResponse";
            const formDataToSend = new FormData();
            formDataToSend.append("entry.1160852334", formData.firstName);
            formDataToSend.append("entry.66592718", formData.lastName);
            formDataToSend.append("entry.1997260862", formData.email);
            formDataToSend.append("entry.717942997", formData.contactNumber);
            formDataToSend.append("entry.305996024", formData.message);

            const response = await fetch(GOOGLE_FORM_URL, {
                method: "POST",
                body: formDataToSend,
                mode: "no-cors",
            });

            if (
                response.type === "opaque" ||
                response.status === 200 ||
                response.ok
            ) {
                setSubmitStatus("success");
                setFormData({
                    firstName: "",
                    lastName: "",
                    email: "",
                    contactNumber: "",
                    message: "",
                });
                setTimeout(() => setSubmitStatus(null), 5000);
            } else {
                setSubmitStatus("error");
                setTimeout(() => setSubmitStatus(null), 5000);
            }
        } catch (error) {
            console.error("Form submission error:", error);
            setSubmitStatus("error");
            setTimeout(() => setSubmitStatus(null), 5000);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div
            id="careers"
            ref={ref}
            className="align-middle items-center justify-center relative overflow-hidden text-center flex flex-col sm:px-10 min-h-[70vh] z-10 p-4"
        >
            <div className="w-[100%] mx-auto text-center md:text-left flex flex-col gap-3">
                <div className="flex flex-col justify-start align-middle items-center">
                    <h2 className="text-center w-[100%] sm:w-[60%] md:w-[700px] lg:w-[700px] xl:w-[1013px] h18 text-[30px] leading-[42px] md:text-[40px] md:leading-[50px] xl:text-[60px] xl:leading-[72px]">
                Let's Discuss your project
                    </h2>

                    {/* Contact Form */}
                    <div className="w-full max-w-2xl mt-14 bg-black/50 backdrop-blur-sm p-8 rounded-2xl">
                        {submitStatus === "success" && (
                            <div className="mb-6 p-4 bg-green-500/20 border border-green-500/50 rounded-xl">
                                <div className="flex items-center space-x-3">
                                    <svg
                                        className="w-6 h-6 text-green-600 flex-shrink-0"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                    <p className="text-green-600 font-semibold">
                                        Thank you! Your message has been sent
                                        successfully.
                                    </p>
                                </div>
                            </div>
                        )}

                        {submitStatus === "error" && (
                            <div className="mb-6 p-4 bg-red-500/20 border border-red-500/50 rounded-xl">
                                <div className="flex items-center space-x-3">
                                    <svg
                                        className="w-6 h-6 text-red-600 flex-shrink-0"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                    <p className="text-red-600 font-semibold">
                                        Something went wrong. Please try again.
                                    </p>
                                </div>
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="space-y-4">
                            <div className="grid md:grid-cols-2 gap-4">
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="First Name *"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    required
                                    disabled={isSubmitting}
                                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:border-white text-white placeholder-white/60 disabled:opacity-50"
                                />
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Last Name *"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    required
                                    disabled={isSubmitting}
                                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:border-white text-white placeholder-white/60 disabled:opacity-50"
                                />
                            </div>

                            <div className="grid md:grid-cols-2 gap-4">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Email *"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    disabled={isSubmitting}
                                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:border-white text-white placeholder-white/60 disabled:opacity-50"
                                />
                                <input
                                    type="tel"
                                    name="contactNumber"
                                    placeholder="Contact Number *"
                                    value={formData.contactNumber}
                                    onChange={handleChange}
                                    required
                                    disabled={isSubmitting}
                                    className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:border-white text-white placeholder-white/60 disabled:opacity-50"
                                />
                            </div>

                            <textarea
                                name="message"
                                placeholder="Message *"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                disabled={isSubmitting}
                                rows={4}
                                className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg focus:outline-none focus:border-white text-white placeholder-white/60 resize-none disabled:opacity-50"
                            />

                            <div className="flex gap-4">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`buttonVariation3 flex-1 ${
                                        isSubmitting
                                            ? "opacity-50 cursor-not-allowed"
                                            : ""
                                    }`}
                                >
                                    {isSubmitting ? "SENDING..." : "SUBMIT"}
                                </button>
                                     <button
                                    href="https://wa.me/917358191224"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="buttonVariation3 flex-1 flex items-center justify-center gap-2"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                                    </svg>
                                    WHATSAPP
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* Contact Info - Add this at the bottom before the closing </div> tags */}
<div className="flex flex-col md:flex-row gap-6 justify-center items-center mt-8 text-white">
    <a 
        href="https://wa.me/917358191224" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center gap-2 hover:opacity-80 transition-opacity"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 16 16"
        >
            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
        </svg>
        <span className="text-white" >+91 7358191224</span>
    </a>
    <span className="hidden md:block">|</span>
    <a 
        href="mailto:ssiddarthsai1999@gmail.com"
        className="flex items-center gap-2 hover:opacity-80 transition-opacity"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            viewBox="0 0 16 16"
        >
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
        </svg>
        <span  className="text-white">ssiddarthsai1999@gmail.com</span>
    </a>
</div>
            <div
                data-depth="0.1"
                className={`absolute inset-0 z-[-10]`}
            >
                <img
                    src={careersbg}
                    alt=""
                    className={`object-cover h-full w-full`}
                />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent z-[-10]"></div>
        </div>
    );
}

export default Careers;